import { render } from "./countDown.vue?vue&type=template&id=af06679c&ts=true"
import script from "./countDown.vue?vue&type=script&lang=ts"
export * from "./countDown.vue?vue&type=script&lang=ts"

import "./countDown.vue?vue&type=style&index=0&id=af06679c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__